(function () {
  // Mark the standalone wishlist page so lytes-custom-fixes.css can turn
  // the app's drawer markup into a normal full-width page, without
  // affecting the drawer if it's ever opened somewhere else.
  if (window.location.pathname.indexOf('/apps/swishlist') === 0) {
    document.documentElement.classList.add('lytes-wishlist-page');
  }

  // Stop the header heart icon from opening the slide-out drawer and
  // send people to the dedicated My Wishlist page instead. Registered
  // on document in the capture phase so it runs before SwishList's own
  // click handler on the button (which is what opens the drawer).
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('.site-header-actions__wishlist .st-wishlist-details-button');
    if (!trigger) return;
    e.preventDefault();
    e.stopPropagation();
    window.location.href = '/apps/swishlist';
  }, true);
})();
